import {BaseUtils} from "./base-utils";

export class BaseStorageUtils extends BaseUtils {
  storage: Storage;

  static injectables = [];

  get(key) {
    const value: String = this.storage[key];
    let returnValue;

    try {
      returnValue = value ? JSON.parse(value) : undefined;
    } catch (e) {
      returnValue = undefined;
    }

    return returnValue;
  }

  getJSON(key) {
    const value: String = this.storage[key];
    let returnValue;

    try {
      returnValue = value ?JSON.parse(JSON.parse(value)) : undefined;
    } catch (e) {
      returnValue = undefined;
    }

    return returnValue;
  }

  set(key, value) {
    return this.storage[key] = JSON.stringify(value);
  }

  setJSON(key, value) {
    return this.storage[key] = JSON.stringify(JSON.stringify(value));
  }

  delete(key) {
    this.storage.removeItem(key);
  }

  deleteAll() {
    this.storage.clear();
  }
}
